

import Vue from 'vue'
import App from './App'
import router from './router'

import axios from 'axios' 








import MetaInfo from 'vue-meta-info';

Vue.use(MetaInfo)






import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'


Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
















import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

let langData = "";

let lang = "zh-hk";
if (langData && JSON.parse(langData).type == true) {
lang = JSON.parse(langData).lang
}


const i18n = new VueI18n({
locale: lang, // 语言标识

messages: {
'zh-cn': require('@/common/lang/zh.js'), // 中文语言包
'zh-hk': require('@/common/lang/tw.js') // 繁體语言包
}
})























router.beforeEach((to, from, next) => {
/* 路由发生变化修改页面title */
if (to.meta.title) {
document.title = to.meta.title;
}
next();
})



console.log('window', window)

let flag = false

let urlData = window.location.href.split('#/')
console.log('urlData', urlData);

let a1 = urlData[urlData.length - 1].split('&')
if (a1.length > 1) {
urlData[urlData.length - 1] = '#/' + a1[0]
flag = true
}
let a2 = urlData[urlData.length - 1].split('?')
if (a2.length > 1) {
urlData[urlData.length - 1] = '#/' + a2[0]
flag = true
}
console.log('flag',flag);
if (flag) {
console.log('new url13,', urlData, urlData.join(''));

window.location.href = urlData.join('')
}


/***
* 图片懒加载插件
*/
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
preLoad: 1.3, //预加载高度
error: require("@/assets/image/icon/img_lazyload.png"),
loading: require("@/assets/image/icon/img_lazyload.png"),
attempt: 1
})

import ccRequest from "./utils/request.js";
Vue.prototype.CCrequest = ccRequest

import ccUtils from "./utils/utils.js";
Vue.prototype.ccUtils = ccUtils

import Epub from "epubjs";
Vue.prototype.Epub = Epub

Vue.prototype.OPENAPP = function () {

if (/android/i.test(navigator.userAgent)) {

if (/MicroMessenger/i.test(navigator.userAgent)) {
alert("微信内置浏览器不支持打开本地应用,请点击右上角使用本地浏览器打开"); 

return
}
}

if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {

if (/MicroMessenger/i.test(navigator.userAgent)) {
alert(
"微信内置浏览器不支持打开本地应用,请点击右上角使用本地浏览器打开"
); //这是微信平台下浏览器
return
}
}


if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
window.location.href = "nowbook://"; 
window.setTimeout(function () {
window.location.href = "itms-apps://itunes.apple.com/cn/app/id1446373183";
}, 2000);
}
if (navigator.userAgent.match(/android/i)) {
window.location.href = "nowbook://nowbook"; 

var href = 'https://play.google.com/store/apps/details?id=com.suep.nowbook';
if (Vue.prototype.isHuawei&&!Vue.prototype.isCHInside) {  // 华为手机并且不是内地的
href = 'https://appgallery1.huawei.com/#/app/C102475257';
}
if (Vue.prototype.isCHInside) {
href =  'http://nowbook.hk/#/download'
}
window.setTimeout(function () {
window.location.href = href;
}, 2000);
}

}


import {
CONFIG,
SERVER
} from "@/api/apiConfig.js";
Vue.prototype.CONFIG = CONFIG
Vue.prototype.SERVER = SERVER

Vue.config.productionTip = false


import "bootstrap/dist/css/bootstrap.min.css"







import utilsFun from "./utils/utils.js";
Vue.prototype.UTILS = utilsFun

if (!utilsFun.chackNative()) {


let obj = {
'system': '',
'versionCode': '',
'appVersion': '',
'deviceId': '',
'networkStatus': '',
'htmlVersion': '1.3.0'
}
Vue.prototype.NATIVEDATA = obj
Vue.prototype.ccIsNative = false
}






import loginFun from "./utils/cc-webapp/login.js";
Vue.prototype.LOGIN = loginFun


import loginFun2 from "./utils/cc-webapp/login2.js";
Vue.prototype.LOGIN2 = loginFun2




var ua = navigator.userAgent;
var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
isAndroid = ua.match(/(Android)\s+([\d.]+)/),
isMobile = isIphone || isAndroid;
Vue.prototype.isMobile = isMobile



Vue.prototype.isHuawei = !!ua.match(/HUAWEI/i);

Vue.prototype.isTraditionalChinese = !!navigator.language.match(/TW|HK/i);
Vue.prototype.isSimplifiedChinese = !!navigator.language.match(/CN/i);
ccRequest.doAxios("/nowbook/media/share/regionType", {}, "POST")
.then(res => {
Vue.prototype.isCHInside = res == 'chInside'||res == '3';
console.log(Vue.prototype.isCHInside)
})


import FBSignInButton from 'vue-facebook-signin-button'
Vue.use(FBSignInButton)


function viewh() {
window.onload = function () {
console.log(document.body.scrollHeight, document.body.clientHeight);
}
}
viewh()

document.documentElement.addEventListener('touchmove', function (event) {
event.preventDefault();
if (event.touches.length > 1) { }
}, false);





































/* eslint-disable no-new */
var vm = new Vue({
el: '#app',
i18n,
FBSignInButton,
router,
components: {
App
},
template: '<App/>',
mounted(){
window.fbAsyncInit = function() {
FB.init({
appId            :  '334680360390712', //'306717654406820',         autoLogAppEvents : true,
xfbml            : true,
version          : 'v3.2'
});
};

(function(d, s, id){
ccRequest.doAxios("/nowbook/media/share/regionType", {}, "POST")
.then(res => {

if(res != 'chInside' && res != '3'){
var js, fjs = d.getElementsByTagName(s)[0];
if (d.getElementById(id)) {return;}
js = d.createElement(s); js.id = id;

js.src = "https://connect.facebook.net/en_US/sdk.js";

fjs.parentNode.insertBefore(js, fjs);
}
})
}(document, 'script', 'facebook-jssdk'));
}
})



// WEBPACK FOOTER //
// ./src/main.js